var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"HeroSection",class:_vm.pageClass ? _vm.pageClass : 'HeroSection'},[_c('div',{staticClass:"HeroWrapper container"},[_c('div',{staticClass:"HeroBody"},[_c('h1',[_vm._v(_vm._s(_vm.title))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }